$shm_hitalama_map_widget_float_ai_request_form $mol_view
	Widget $shm_hitalama_map_widget_float_ai_request
	text \
	prompt \
	paste null
	next_request null
	next_request_type \
